module.exports = require('./EntityOfficerChangeApplicationView');
